module.exports = require('./EntityOfficerChangeApplicationView');
